import Vue from 'vue'
import App from './App.vue'
import store from './store'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-1992007-55',
  beforeFirstHit () {
    Vue.$ga.set('anonymizeIp', true)
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
